<template lang="pug">
el-dialog(v-dialog-drag, width="1250px", top="60px", title="快速添加字段", :visible.sync="visible", :close-on-click-modal="false", :closed="reject")
  .container
    .filter-form
      .filter-item
        el-cascader(v-model="filterForm.tableName", placeholder="筛选流程模块", clearable, size="small", filterable, :props="cascaderProps", :options="options", @change="getList(1)")
      .filter-item
        el-input(v-model="filterForm.keyWord", @keydown.native.enter="getList(1)", size="small", placeholder="搜索内部名称、显示名称", clearable, prefix-icon="el-icon-search")
          el-button(slot="append", size="small", @click="getList(1)") 搜索
    .body
      el-table(
        ref="table",
        :data="list",
        height="100%",
        row-key="metaId",
        highlight-selection-row,
        :default-sort="{ prop: 'columnName', order: 'ascending' }",
        @selection-change="selectionChange"
      )
        el-table-column(width="40px", align="center", type="selection", reserve-selection, :selectable="filterSelection")
        el-table-column(width="50px", align="center", type="index", label="序号", :index="(page.pageIndex - 1) * page.pageSize + 1")
        el-table-column(prop="columnName", label="内部名称", min-width="150px", show-overflow-tooltip)
        //- sortable,
        el-table-column(prop="columnDisplayName", label="显示名称", min-width="150px", show-overflow-tooltip)
        el-table-column(v-slot="{ row }", prop="tableName", label="来源字段", min-width="150px", show-overflow-tooltip)
          a.table-link(@click="setTableName(row.tableName)") {{ row.businessName }}({{ row.tableName }})
        el-table-column(prop="userTypeName", label="数据类型", width="80", align="center", show-overflow-tooltip)
        el-table-column(v-slot="{ row }", prop="isNullable", width="50", align="center", label="必填")
          el-checkbox(:true-label="0", :value="row.isNullable")
        el-table-column(prop="maxLength", align="center", width="80", label="内部长度")
        el-table-column(prop="displayDataLength", align="center", width="80", label="业务长度")
        el-table-column(prop="defaultValue", align="center", label="默认值", width="70px", show-overflow-tooltip)
        el-table-column(v-slot="{ row }", prop="isInternalField", align="center", label="内部字段", width="80px")
          el-checkbox(:true-label="1", :value="row.isInternalField")
        el-table-column(v-slot="{ row }", prop="isCustomField", label="表字段", width="70", align="center")
          el-checkbox(:true-label="0", :value="row.isCustomField")
        el-table-column(prop="remark", width="150px", label="备注", show-overflow-tooltip)
    .right(tabindex="0", :class="{ active: showAside }")
      .aside-bar(@click="toggleAside()") 已选数据
      .aside-plain
        .tag-group
          .tag-label 已选数据 ({{ selection.length }})
          .tag-container(v-if="selection.length")
            dl(v-for="(selection, tableName) in fieldGroup", :key="tableName")
              dt.table-group
                .table-group-label.table-link(@click="setTableName(tableName)") {{ tableNameMap[tableName] }}
                .table-group-count (共{{ selection.length }}条)
              dd(v-for="row in selection", :key="row.columnName")
                .field-label {{ row | field }}
                i.el-icon-delete(@click="onTagClose(row)")
  template(#footer)
    .footer
      el-pagination(
        layout="total, prev, pager, next, jumper",
        @current-change="getList",
        :current-page.sync="page.pageIndex",
        :page-size="page.pageSize",
        :total="page.totalCount"
      )
      el-button(size="small", @click="close()") 取消
      el-button(size="small", type="primary", @click="submit()") 确定
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import metadataService from "@/CommonDP/service/metadata-service";
import { get, groupBy, template } from "lodash-es";

export default {
  filters: {
    field(row) {
      const tem = template("${columnDisplayName}(${columnName})");
      return tem(row);
    }
  },
  mixins: [asyncMixin],
  props: {
    fieldKeys: { default: () => [], type: Array },
    tableId: { default: "", type: String }
  },
  data() {
    return {
      page: { totalCount: 0, pageSize: 50, pageIndex: 1 },
      filterForm: {
        tableName: "", // 下拉选中的表
        keyWord: ""
      },
      showAside: false,
      visible: false,
      cascaderProps: {
        children: "children",
        label: "groupName",
        value: "groupId",
        emitPath: false
      },
      tableNameMap: {},
      options: [],
      list: [],
      selection: []
    };
  },
  computed: {
    fieldGroup() {
      return groupBy(this.selection, "tableName");
    }
  },
  async created() {
    this.getModuleList();
    this.visible = true;
  },
  methods: {
    toggleAside(toAside = !this.showAside) {
      this.showAside = toAside;
      this.page.pageIndex = 1;
    },
    selectionChange(list) {
      const nameSet = new Set();
      const newList = [];
      const dupList = [];
      for (const row of list) {
        const { columnName } = row;
        if (nameSet.has(columnName)) {
          dupList.push(row);
        } else {
          newList.push(row);
          nameSet.add(columnName);
        }
      }
      if (dupList.length) for (const row of dupList) this.onTagClose(row);
      else this.selection = newList;
    },
    // 本表已有字段和和已选择同名字段(不包含已选择)将会禁止选择
    filterSelection(row) {
      return !this.fieldKeys.some((k) => row.columnName === k) && !this.selection.some(({ columnName, metaId }) => columnName === row.columnName && metaId !== row.metaId);
    },
    onTagClose(row) {
      this.$refs.table.toggleRowSelection(row, false);
    },
    // 获取下拉数据
    async getModuleList() {
      const { tableNameMap } = this;
      const { data } = await metadataService.dynFormGroupList({});
      const options = [];
      const format = template("${groupName}(${groupId})");

      // 获取业务模型
      for (const l1 of data) {
        if (l1.parentId !== "0") continue;
        if (!l1.children?.length) continue;
        const c1 = [];
        for (const l2 of l1.children) {
          let c2 = [];
          if (!l2.children?.length) continue;
          c2 = get(l2, "children[0].children", []).map((r) => {
            r.groupName = format(r);
            this.$set(tableNameMap, r.groupId, r.groupName);
            return r;
          });
          l2.children = c2;
          if (c2.length) c1.push(l2);
        }
        l1.children = c1;
        if (c1.length) options.push(l1);
      }
      this.options = options;
      this.getList(1);
    },
    async setTableName(tableName = this.filterForm.tableName) {
      this.filterForm.tableName = tableName;
      await this.getList(1);
    },
    // 获取字段列表,并缓存
    async getList(pageIndex1 = this.page.pageIndex, pageSize1 = this.page.pageSize) {
      const {
        filterForm: { tableName, keyWord }
      } = this;
      const { data, pageIndex, pageSize, totalCount } = await metadataService.queryOtherMetaColumnList({ tableName, pageNum: pageIndex1, pageSize: pageSize1, keyWord });
      Object.assign(this.page, { pageIndex, totalCount, pageSize });
      this.list = data || [];
    },
    close() {
      this.visible = false;
    },
    submit() {
      this.resolve(this.selection);
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
$color: #4777e7;
.container {
  height: 600px;
  position: relative;
  display: flex;
  flex-flow: nowrap column;
  overflow: hidden;
  > .right {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 2;
    left: 100%;
    transition: all 0.2s;
    width: 270px;
    transition-delay: 0.3s;
    &.active,
    &:focus,
    &:focus-visible,
    &:focus-within,
    &:hover {
      transform: translateX(-100%);
      transition-delay: 0s;
    }
  }
}
.table-link {
  cursor: pointer;
  &:hover,
  &:active {
    color: $color;
    text-decoration-line: underline;
  }
}
.aside {
  &-bar {
    position: absolute;
    background-color: $color;
    color: #fff;
    top: 0;
    bottom: 0;
    text-align: center;
    line-height: 1.45;
    height: 6em;
    width: 1.8em;
    margin: auto 0;
    right: 100%;
    cursor: pointer;
    user-select: none;
    border-radius: 4px 0 0 4px;
  }
  &-plain {
    background-color: #fff;
    height: 100%;
    box-shadow: 0 0 30px -25px #000, 0 0 5px #0003;
  }
}
.tag {
  &-group {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    margin: 0 4px;
  }
  &-label {
    color: #999;
    user-select: none;
    font-size: 14px;
    margin: 8px 8px 4px;
    flex-shrink: 0;
  }
  &-container {
    flex-grow: 1;
    overflow-y: auto;
    .table-group {
      @extend %item;
      position: sticky;
      top: 0;
      padding: 2px 8px;
      background: linear-gradient(to right, $color, lighten($color, 35%) 200%);
      border-radius: 4px;
      &-label {
        @extend %item-label;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        > i {
          margin-right: 4px;
          cursor: pointer;
          &:hover {
            color: $color;
          }
        }
      }
      &-count {
        @extend %item-append;
        user-select: none;
        font-size: 12px;
        color: #fff;
      }
    }
    dd {
      @extend %item;
      padding: 6px 8px;
      cursor: default;
      .field-label {
        @extend %item-label;
      }
      .el-icon-delete {
        cursor: pointer;
        @extend %item-append;
        color: red;
      }
      &:hover {
        background-color: lighten($color, 38%);
      }
    }
  }
}
%item {
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  white-space: nowrap;
  &-label {
    flex-grow: 1;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &-append {
    flex: 0 0;
  }
}
.body {
  flex-grow: 1;
  overflow: hidden;
}
.filter-form {
  flex-shrink: 0;
  display: flex;
  flex-flow: nowrap row;
  justify-content: space-evenly;
  margin: 6px 0;
  .el-cascader {
    width: 400px;
  }
  .el-input {
    width: 300px;
  }
  .filter-item {
    flex: 1 1;
    &:last-child {
      flex: 0 0 300px;
    }
  }
}
.footer {
  display: flex;
  flex-flow: nowrap row;
  justify-content: flex-start;
  > .el-pagination {
    text-align: left;
    flex-grow: 1;
  }
  > .el-button {
    flex-grow: 0;
  }
}
.empty {
  height: 200px;
  padding-top: 40px;
  font-size: 24px;
  font-weight: bold;
  color: #ddd;
  text-align: center;
}
</style>
